<template>
    <glass-panel
        radius="lg"
        class="glass-data-table-panel"
    >
        <v-data-table
            v-bind="$attrs"
            v-on="$listeners"
        >
            <template
                v-for="(_, slotName) in $scopedSlots"
                #[slotName]="slotProps"
            >
                <slot
                    :name="slotName"
                    v-bind="slotProps"
                />
            </template>
        </v-data-table>
    </glass-panel>
</template>

<script>
export default {
    name: 'GlassDataTable',
    inheritAttrs: false,
}
</script>
